import React, { Component } from 'react';
import { base, } from '../../../config/constants';
import { Button, Image, Form, Input } from 'semantic-ui-react'
import * as UiConsts from '../../../config/UiConstants'

class ViewImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            imageUrl: '',
            orderNumber:'',
            loading:false,
            orderFound:''
        }
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    loadImage = () => {
        console.log("+++++++: load image");
        console.log("order number:"+this.state.orderNumber);

        this.setState({
            loading:true
        })

        base.fetch('orders', {
            context: this,
            asArray: true,
            queries: {
                orderByChild: 'order_num',
                equalTo: parseInt(this.state.orderNumber)
            },
            then(data) {
                console.log("rlx141 order:" + JSON.stringify(data[0], null, 2));

                if (data.length > 0) {
                    console.log("rlx15 found order");

                    this.setState({
                        order: data[0],
                        imageUrl: data[0].designImageUrl,
                        orderNotFound:false
                    })
                    // userFromFirebaseUserNode = data[0];
                    // log("rlx16 get userFromFirebaseUserNode?:"+data[0].email);

                } else {
                    console.log("rlx151 user NOT found");
                    this.setState({ orderNotFound: true })
                }

                //remove loading
                this.setState({ loading: false })
            }
        });
    }

    render() {

      const orderButton = this.state.orderNumber.length === 4
        ?  <Button onClick={this.loadImage}>GET IMAGE</Button>
        : ''

        const orderNotFound = this.state.orderNotFound 
        ? <h1> ORDER NOT FOUND </h1>
        : <Image src={this.state.imageUrl} fluid />

        const loadingImage = this.state.loading === true 
            ? <UiConsts.LoadingComponent /> 
            : <div>{orderNotFound}</div>



        return (
            <div>
                <h1>FIND IMPRESSION</h1>
                <h4>ORDER NUMBER MUST BE 4 DIGITS</h4>
                <Form onSubmit={this.loadImage}>
                    <Form.Field
                        name={'orderNumber'}
                        value={this.state.orderNumber}
                        control={Input}
                        placeholder={this.props.templateSpecialFieldLabel}
                        onChange={this.handleTextInputChange} />
                    {orderButton}
                </Form>
                {loadingImage}
                {/* <h2>imageUrls:{this.state.imageUrl}</h2> */}
                
            </div>
        )
    }
}

export default ViewImage;


// WEBPACK FOOTER //
// ./src/components/newSite/ViewImage/ViewImage.js